@if (text(); as body) {
  <div
    class="toast-pop"
    [class.is-error]="tone() === 'error'"
    [class.is-leaving]="isLeaving()"
    role="status"
    aria-live="polite"
  >
    <span class="toast-pop-icon" aria-hidden="true">
      @if (tone() === 'error') {
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <circle cx="12" cy="12" r="9" /><path d="M12 8v5M12 16h.01" />
        </svg>
      } @else {
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="9" /><path d="m8.5 12.5 2.5 2.5 4.5-5" />
        </svg>
      }
    </span>
    <span class="toast-pop-text">{{ body }}</span>
    <button type="button" class="toast-pop-close" (click)="dismiss()" aria-label="Dismiss message">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" />
      </svg>
    </button>
  </div>
}
